module.exports = __webpack_public_path__ + "static/media/data.76354149.svg";